import { FETCH_STATUSES } from 'resources'
import actions from './actions'

export const initialState = {
  status: FETCH_STATUSES.NOOP,
  count: 0,
  transactions: [],
}

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case actions.fetchTransactions.INIT_TYPE: {
      return {
        ...state,
        status: FETCH_STATUSES.FETCHING,
      }
    }
    case actions.fetchTransactions.SUCCESS_TYPE: {
      return {
        ...state,
        status: FETCH_STATUSES.SUCCESS,
        count: payload.count,
        transactions: payload.results,
      }
    }
    case actions.fetchTransactions.FAILURE_TYPE: {
      return {
        ...state,
        status: FETCH_STATUSES.FAILURE,
      }
    }
    case 'RESET': {
      return initialState
    }
    default:
      return state
  }
}

export default reducer
